import EmptyView1 from '../../layouts/EmptyView1'
import Subscribe from './Subscribe'

export default EmptyView1(Subscribe)
